import { Outlet } from "react-router-dom";
import "../styles/layouts-styles/MainDashboardLayout.css"
import MainDashboardHeader from "../components/headers/MainDashboardHeader";
import MainDashboardSidebar from "../components/sidebar/MainDashboardSidebar";
import { useContext } from "react";
import { SidebarContext } from "../contexts/SidebarContext";
import HighYieldTextbookSidebar from "../components/sidebar/HighYieldTextbookSidebar";
import ExtendedTextbookSidebar from "../components/sidebar/ExtendedTextbookSidebar";
import UserProfileSidebar from "../components/sidebar/UserProfileSidebar";

function MainDashboardLayout () {
    const { showSidebar } = useContext(SidebarContext);
    return(
        
        <div className="main-dashboard-layout-container">
            <MainDashboardSidebar />
            <HighYieldTextbookSidebar />
            <ExtendedTextbookSidebar />
            <UserProfileSidebar />
            <div className={
                `main-dashboard-header-and-main-content-container ${showSidebar ? 'sidebar-open' : 'sidebar-closed'}`
                }
            >
                <MainDashboardHeader />
                <div className="main-dashboard-main-content-container">
                    <Outlet />
                </div>
            </div>
        </div>
        
    )
    
}

export default MainDashboardLayout;